import { render } from "./InvestmentPanel.vue?vue&type=template&id=39af33be"
import script from "./InvestmentPanel.vue?vue&type=script&lang=js"
export * from "./InvestmentPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__